export default [
  {
    title: 'core.system',
    description: 'core.system_description',
    children: [
      {
        title: 'core.translations',
        icon: 'language',
        requiredPermissions: [
          'POST api/system/translations/client-translations',
          'POST api/system/translations/server-translations'
        ],
        target: 'system.translation_list'
      },
      {
        title: 'sandoz.plan_data_import',
        icon: 'file-import',
        requiredPermissions: [
          'POST api/sandoz/plan_data/{id}',
          'DELETE api/sandoz/plan_data/{id}'
        ],
        target: 'sandoz.file_import'
      },
      {
        title: 'sandoz.export_jobs',
        icon: 'history',
        requiredPermissions: [
          'POST api/sandoz/export_jobs/{id}',
          'DELETE api/sandoz/export_jobs/{id}'
        ],
        target: 'sandoz.export_jobs'
      },
      {
        title: 'sandoz.warehouse_import_jobs',
        icon: 'file-import',
        requiredPermissions: [
          'GET api/sandoz/warehouse_import_jobs'
        ],
        target: 'sandoz.warehouse_import_jobs'
      },
      {
        title: 'sandoz.wholesalers',
        icon: 'cart-shopping',
        requiredPermissions: [
          'POST api/wholesalers/{id}',
        ],
        target: 'sandoz.wholesaler.list'
      },
      {
        title: 'sandoz.buying_groups',
        icon: 'layer-group',
        requiredPermissions: [
          'POST api/buying_groups/{id}',
        ],
        target: 'sandoz.buying_group.list'
      },
      {
        title: 'sandoz.kuko_products',
        icon: 'folder-tree',
        requiredPermissions: [
          'POST api/kuko-products/{id}',
        ],
        target: 'sandoz.kuko_product.list'
      },
      {
        title: 'sandoz.kuko_product_groups',
        icon: 'percent',
        target: 'sandoz.product.group.list',
        requiredPermissions: [
          'POST api/kuko_product_groups/{id}',
        ],
      },
      {
        title: 'sandoz.kuko_condition_groups',
        icon: 'percent',
        target: 'sandoz.condition.group.list',
        requiredPermissions: [
          'POST api/kuko_condition_groups/{id}',
        ],
      },
      {
        title: 'core.audit_log',
        icon: 'stamp',
        requiredPermissions: [
          'POST api/system/audit_log/{id}',
          'DELETE api/system/audit_log/{id}'
        ],
        target: 'system.audit_log'
      },
      {
        title: 'core.data_changes',
        icon: 'dice',
        requiredPermissions: [
          'POST api/system/data_changes/{id}',
          'DELETE api/system/data_changes/{id}'
        ],
        target: 'system.data_changes'
      },
      {
        title: 'core.notifications',
        icon: 'envelope',
        requiredPermissions: [
          'POST api/system/notifications/{id}',
          'DELETE api/system/notifications/{id}'
        ],
        target: 'system.notification_list'
      },
      {
        title: 'sandoz.pv_external_ids',
        icon: 'fingerprint',
        requiredPermissions: [
          'POST api/pv_external_ids/{id}',
        ],
        target: 'sandoz.pv.external_ids'
      }
    ]
  },
  {
    title: 'sandoz.contracts',
    icon: 'file-signature',
    requiredPermissions: [
      'GET api/sandoz/contracts'
    ],
    target: 'sandoz.contracts'
  },
  {
    title: 'sandoz.kam_contracts',
    icon: 'file-signature',
    requiredPermissions: [
      'GET api/sandoz/kam/contracts'
    ],
    target: 'sandoz.kam.contracts'
  },
  {
    title: 'sandoz.ice_peak_contracts',
    icon: 'file-signature',
    requiredPermissions: [
      'GET api/sandoz/ice-peak/contracts'
    ],
    target: 'sandoz.ice_peak.contracts'
  },
  {
    title: 'sandoz.pv_contracts',
    icon: 'file-signature',
    requiredPermissions: [
      'GET api/sandoz/pv/contracts'
    ],
    target: 'sandoz.pv.contracts'
  },
  {
    title: 'sandoz.apo_one_contracts',
    icon: 'file-signature',
    requiredPermissions: [
      'GET api/sandoz/apo-one/contracts'
    ],
    target: 'sandoz.apo_one.contracts'
  },
  {
    title: 'sandoz.gadget_contracts',
    icon: 'file-signature',
    requiredPermissions: [
      'GET api/sandoz/gadget/contracts'
    ],
    target: 'sandoz.gadget.contracts'
  },
  {
    title: 'sandoz.educational_contracts',
    icon: 'file-signature',
    requiredPermissions: [
      'GET api/sandoz/educational/contracts'
    ],
    target: 'sandoz.educational.contracts'
  },
  {
    title: 'sandoz.tracking',
    description: 'sandoz.tracking_info',
    children: [
      {
        title: 'sandoz.contracts_pdf_upload',
        icon: 'file-pdf',
        requiredPermissions: [
          'POST api/sandoz/contracts/{id}',
          'DELETE api/sandoz/contracts/{id}'
        ],
        target: 'sandoz.contracts_pdf_upload'
      },
      {
        title: 'sandoz.deliveries',
        icon: 'truck',
        requiredPermissions: [
          'POST api/sandoz/contract_line_deliveries/{id}',
          'DELETE api/sandoz/contract_line_deliveries/{id}'
        ],
        target: 'sandoz.deliveries'
      },
      {
        title: 'sandoz.bulk_delivery',
        icon: 'truck',
        requiredPermissions: [
          'POST api/sandoz/contract_line_deliveries/{id}',
          'DELETE api/sandoz/contract_line_deliveries/{id}'
        ],
        target: 'sandoz.bulk_delivery'
      },
      {
        title: 'sandoz.service_management',
        icon: 'truck',
        requiredPermissions: [
          'POST api/sandoz/contract_line_deliveries/{id}',
          'POST api/sandoz/contract_line_deliveries/save_bulk_note',
          'POST api/sandoz/contract_line_deliveries/update_delivery_date'
        ],
        target: 'sandoz.service_management'
      },
      {
        title: 'sandoz.item_classification',
        icon: 'envelope-circle-check',
        requiredPermissions: [
          'GET api/sandoz/item_classifications'
        ],
        target: 'sandoz.item_classification_list'
      },
      {
        title: 'sandoz.chargebacks',
        icon: 'envelope-circle-check',
        requiredPermissions: [
          'GET api/chargebacks'
        ],
        target: 'sandoz.chargebacks.list'
      },
      {
        title: 'sandoz.educational_courses',
        icon: 'graduation-cap',
        requiredPermissions: [
          'GET api/sandoz/educational/courses/{contractId}'
        ],
        target: 'sandoz.tracking.educational_courses'
      },
    ]
  },
  {
    title: 'sandoz.excel_reports',
    icon: 'table',
    requiredPermissions: [
      'POST api/sandoz/reports/{id}',
      'DELETE api/sandoz/reports/{id}'
    ],
    target: 'sandoz.reports'
  },
  {
    title: 'sandoz.approvals',
    icon: 'user-check',
    requiredPermissions: [
      'POST api/sandoz/approvals/{id}',
      'DELETE api/sandoz/approvals/{id}'
    ],
    target: 'sandoz.approvals'
  },
  {
    title: 'sandoz.verification_overview',
    children: [
      {
        title: 'sandoz.kam_archive',
        icon: "check-double",
        requiredPermissions: [
          'GET api/sandoz/kam_verifications/{id}'
        ],
        target: 'sandoz.kam_verifications_archive'
      },
      {
        title: 'sandoz.kam',
        icon: "check-double",
        requiredPermissions: [
          'GET api/sandoz/kam_item_verifications/{id}'
        ],
        target: 'sandoz.kam_item_verifications'
      },
      {
        title: 'sandoz.others',
        icon: "check-double",
        requiredPermissions: [
          'GET api/sandoz/verifications/{id}'
        ],
        target: 'sandoz.verifications'
      }
    ]
  },
  // {
  //   title: 'sandoz.verifications_old',
  //   icon:"check-double",
  //   requiredPermissions: [
  //     'GET api/verifications/contracts',
  //     'POST api/verifications/deny',
  //     'POST api/verifications/allow',
  //     'POST api/verifications/delete-picture',
  //     'POST api/verifications/upload-picture',
  //     'GET api/verifications/contracts/{id}'
  //   ],
  //   target: 'verifications.verifications'
  // },
  {
    title: 'sandoz.verifications',
    icon: "check-double",
    requiredPermissions: [
      'GET api/verifications-new/contracts',
      'POST api/verifications/deny',
      'POST api/verifications/allow',
      'POST api/verifications/delete-picture',
      'POST api/verifications/upload-picture',
      'GET api/verifications-new/contracts/{id}/{year}/{address}'
    ],
    target: 'verifications.new_verifications'
  },
  {
    title: 'sandoz.cp_customers',
    icon: 'building',
    requiredPermissions: [
      'GET api/customers'
    ],
    target: 'customers.list'
  },
  {
    title: 'sandoz.cp_logins',
    icon: 'right-to-bracket',
    requiredPermissions: [
      'GET api/customer-logins'
    ],
    target: 'customer_logins.list'
  },
  {
    title: 'sandoz.product_management',
    description: 'sandoz.product_management_info',
    children: [
      {
        title: 'sandoz.sales_lines',
        icon: 'shipping-fast',
        requiredPermissions: [
          'POST api/sandoz/sales_lines/{id}',
          'DELETE api/sandoz/sales_lines/{id}'
        ],
        target: 'sandoz.sales_lines'
      },
      {
        title: 'sandoz.products',
        icon: 'luggage-cart',
        requiredPermissions: [
          'POST api/sandoz/product_masters/{id}',
          'DELETE api/sandoz/product_masters/{id}'
        ],
        target: 'sandoz.products'
      },
      {
        title: 'sandoz.product_matrix',
        icon: 'table',
        requiredPermissions: [
          'GET api/sandoz/product_matrix',
          'POST api/sandoz/product_master_sales_lines/{id}'
        ],
        target: 'sandoz.product_matrix'
      },
      {
        title: 'sandoz.product_price_matrix',
        icon: 'dollar-sign',
        requiredPermissions: [
          'GET api/sandoz/product_price_matrix',
          'POST api/sandoz/product_master_prices/{id}'
        ],
        target: 'sandoz.product_price_matrix'
      },
      {
        title: 'sandoz.product_master_matrix',
        icon: 'cogs',
        requiredPermissions: [
          'GET api/sandoz/product_master_matrix',
          'POST api/sandoz/product_master_matrix'
        ],
        target: 'sandoz.product_master_matrix'
      }]
  },
  {
    title: 'sandoz.wholesaler_management',
    description: 'sandoz.wholesaler_management_info',
    children: [
      {
        title: 'sandoz.sales_reallocation',
        icon: 'shopping-bag',
        requiredPermissions: [
          'POST api/sandoz/customer_match/{id}',
          'DELETE api/sandoz/customer_match/{id}'
        ],
        target: 'sandoz.sales_reallocation'
      },
      {
        title: 'sandoz.kick_outs',
        icon: 'shopping-basket',
        requiredPermissions: [
          'POST api/sandoz/wholesaler_kickout_match/{id}',
          'DELETE api/sandoz/wholesaler_kickout_match/{id}',
        ],
        target: 'sandoz.kick_outs'
      }]
  },
  {
    title: 'sandoz_sortalys.sortalys',
    children: [
      {
        title: 'sandoz_sortalys.bezugs_statistik',
        icon: 'chart-area',
        requiredPermissions: [
          'GET api/sandoz_sortalys/bezugsstatistik'
        ],
        target: 'sandoz_sortalys.bezugs_statistik_list'
      },
      {
        title: 'sandoz_sortalys.assortment_analysis',
        icon: 'chart-area',
        requiredPermissions: [
          'GET api/sandoz/assortment_analysis'
        ],
        target: 'sandoz_sortalys.assortment_analysis_list'
      }
    ]
  },
  {
    title: 'sandoz.statistics',
    children: [
      {
        title: 'sandoz.statistic_marketing_activities',
        icon: 'chart-area',
        requiredPermissions: [
          'GET api/sandoz/statistics/marketing_activities'
        ],
        target: 'sandoz.statistic_marketing_activities'
      },
      {
        title: 'sandoz.statistic_services',
        icon: 'chart-area',
        requiredPermissions: [
          'GET api/sandoz/statistics/services'
        ],
        target: 'sandoz.statistic_services'
      },
      {
        title: 'sandoz.statistic_contracts',
        icon: 'chart-area',
        requiredPermissions: [
          'GET api/sandoz/statistics/contracts'
        ],
        target: 'sandoz.statistic_contracts'
      }
    ]
  },
  {
    title: 'sandoz.customer_platform',
    children: [
      {
        title: 'sandoz.customer_logins',
        icon: 'right-to-bracket',
        requiredPermissions: [
          'GET api/sandoz/customer_logins'
        ],
        target: 'sandoz.customer_platform.customer_logins_list'
      },
      {
        title: 'sandoz.contract_invoices',
        icon: 'dollar-sign',
        requiredPermissions: [
          'GET api/sandoz/contract_invoices'
        ],
        target: 'sandoz.customer_platform.contract_invoices_list'
      }
    ]
  },
  {
    title: 'sandoz.kukos',
    icon: 'percent',
    target: 'sandoz.kuko.list',
    requiredPermissions: [
      'GET api/kukos'
    ],
  },
  {
    title: 'sandoz.pass_through_controls',
    icon: 'arrows-left-right',
    requiredPermissions: [
      'GET api/pass_through_controls',
    ],
    target: 'sandoz.pass_through_controls.list'
  }
]
